import React from 'react';
import ProCommodity55 from './ProCommodity55';
import ProVerticalCarousel33 from './ProCarousel/ProVerticalCarousel33';

import displayCurated from './imgs33/display-curated.png';
import displayContent from './imgs33/display-content.png';
import messagingScene from './imgs33/messaging-scene.png';
import settingScene from './imgs33/setting-scene.png';
import featureDisplay from './imgs33/feature-display.png';
import featureMounting from './imgs33/feature-mounting.png';
import featureSpeakers from './imgs33/feature-speakers.png';
import featureFrames from './imgs33/feature-frames.png';

const PRODUCT_CONFIG = {
    CarouselComponent: ProVerticalCarousel33,
    fillDetailsColumn: true,
    productTitle: '33” Square Textura Pro Digital Canvas',
    productIntro: 'Experience art in a striking square format and advanced texture-accurate display technology that brings every brushstroke and intricate detail to life in vivid realism.',
    productBullets: [
        'Installation is quick and flexible. Hang the display using the concealed rear wire or use the VESA mounting holes for a more permanent installation.',
        'Choose from Black, Walnut or White premium hardwood frames to complement your décor or branding, creating a tailored finish that suits any space.',
        'Take full control with the Vieunite Pro Portal, offering simple, flexible and fully customisable content management for your display.',
        'All Vieunite Pro products come with a 3-year commercial warranty, with on-site support available across mainland UK.'
    ],
    primaryCtaLabel: 'ENQUIRY',
    messagingTitle: {
        prefix: 'Refine Your ',
        accent: 'Corporate Messaging'
    },
    mobileMessagingTitle: {
        prefix: 'Refine Your ',
        accent: 'Corporate Messaging'
    },
    sceneTitle: {
        prefix: 'Setting the ',
        accent: 'Scene'
    },
    mobileSceneTitle: {
        prefix: 'Setting the ',
        accent: 'Scene'
    },
    mobileSceneCta: {
        label: 'EXPLORE SOFTWARE',
        link: '/pro/software'
    },
    page1: [
        [
            'Unique Aspect Ratio Display',
            'The unique square aspect ratio enhances visual storytelling, ideal for artwork and content that does not fit the traditional 16:9 layout. Video and static content viewed in 1:1 ratio provides an authentic and captivating viewing experience.',
            'link'
        ],
        [
            'Flexible Content Playback',
            'Textura Pro gives you total flexibility for displaying content. Manage and schedule artwork directly via the Vieunite Pro Portal, run third-party apps on the integrated Android 14 media player, or connect an external device via HDMI.',
            'link'
        ]
    ],
    page2: [
        [
            'Curated Collections & Art Library',
            'Unlock a world of inspiration with the vast, expertly curated Vieunite Art Library, featuring works from emerging talent and world-renowned galleries. Rotate collections, create personalised playlists, or bring classic masterpieces into any space for a constantly fresh, gallery-quality experience.',
            'link'
        ],
        [
            'Vieunite Pro CMS',
            'Take full control of your Textura with our advanced content management system. Easily schedule, update, and organise content across multiple canvases through a secure, intuitive platform.',
            'link'
        ]
    ],
    sectionBackground1: messagingScene,
    sectionBackground2: settingScene,
    displayContentCards: [
        {title: 'Exhibit curated artwork', image: displayCurated},
        {title: 'Display your own content', image: displayContent}
    ],
    engineeredForArtistryCards: [
        {
            title: 'Ultra-Faithful Display',
            image: featureDisplay,
            imageStyle: {objectPosition: 'center bottom'}
        },
        {
            title: 'Easy Mounting',
            image: featureMounting,
            imageStyle: {objectPosition: 'center bottom'}
        },
        {
            title: 'Integrated Speakers',
            image: featureSpeakers,
            imageStyle: {objectPosition: 'center bottom'}
        },
        {
            title: 'Multiple Frame Options',
            image: featureFrames,
            imageStyle: {objectPosition: 'center bottom'}
        }
    ],
    modelNumber: 'VT33WGV1',
    specificationSections: [
        {
            title: 'Display',
            items: [
                ['Resolution (px)', '1920 x 1920'],
                ['Display/Active Area (mm)', '596.16 x 596.16'],
                ['Aspect Ratio', '1:1'],
                ['Brightness', '400cd/m2'],
                ['Colour', '1.07 Billions (8bit + 2bit FRC); 72% NTSC'],
                ['Haze Level', '25%'],
                ['Viewing Angle (°)', '89/89/89/89'],
                ['Contrast Ratio', '1,000: 1'],
                ['Orientation Support', 'N/A'],
                ['Operating Hours', '24/7 Commercial Use']
            ]
        },
        {
            title: 'System & Performance',
            items: [
                ['CPU', 'RK3568 64bit Cortex-A55 Quad @2GHz'],
                ['GPU', 'Mali-G52 MP2'],
                ['Graphics API Support', 'OpenGL ES 1.1/2.0/3.2, OpenCL 2.0 and Vulkan 1.1'],
                ['OS Operating System', 'Android 14'],
                ['RAM', '4GB'],
                ['Storage', '64GB'],
                ['Media Format', 'Supports FHD 60FPS H.264/H.265 video encoding'],
                ['LAN', '10/100/1000M RJ45'],
                ['Wi-Fi', 'Dual-band 2.4GHz / 5GHz (802.11a/b/g/n/ac)'],
                ['Bluetooth', '5.0']
            ]
        },
        {
            title: 'Connectivity & Interface',
            items: [
                ['HDMI', '1 x HDMI 2.0 IN'],
                ['USB', '1 × USB 3.0 Type-A; 1 x USB 2.0 Type-A; 1 x USB Type-C (OTG only)'],
                ['RS-232', '1 x RJ45 (Serial Control)'],
                ['Ethernet', '1 x RJ45 (10/100/1000M)'],
                ['Audio Out', '1 x 3.5mm Audio Out'],
                ['Expansion Slot', '1 x Micro SD'],
                ['Power Input', '1 x IEC C5'],
                ['Switch', '1 x Power Switch'],
                ['Speakers', '2 x 2W'],
                ['4G Module (Optional)', '1 x SIM In']
            ]
        },
        {
            title: 'Power Management',
            items: [
                ['Power Supply', 'AC 100-240V, 50/60Hz'],
                ['Power Consumption', 'Typical 55 W; Max: TBC'],
                ['Standby Power', '≤0.5W']
            ]
        },
        {
            title: 'Dimensions & Weight',
            items: [
                ['Screen Dimensions (mm)', '645 x 645 x 40'],
                ['Package Dimensions (mm)', '760 x 760 x 110'],
                ['VESA Mounting (mm)', '200 x 200 M6 12mm'],
                ['Net Weight (Including Frame and Wall Mount)', '10 kg'],
                ['Gross Weight (Including Frame and Wall Mount)', '12 kg']
            ]
        },
        {
            title: 'Environmental Conditions',
            items: [
                ['Operating Temperature (°C)', '0 to 40°C'],
                ['Storage Temperature (°C)', '-10°C to 55°C'],
                ['Operating Relative-Humidity (%)', '10% to 80%'],
                ['Storage Relative-Humidity', '10% to 80%']
            ]
        },
        {
            title: 'Accessories',
            items: [
                ['Included Accessories', 'Real Wood Frame (Walnut, White or Black), 1.8m IEC C6 UK Power Lead, Remote Control, 2x AAA batteries, Wall Mount'],
                ['Optional Accessories', 'Additional Walnut Frame, White Frame or Black Frame']
            ]
        },
        {
            title: 'Warranty',
            items: [
                ['Warranty Period', '3 Years'],
                ['Technical Support', 'Lifetime']
            ]
        }
    ],
    downloads: [
        {
            href: 'https://vieunite.com/VT33WGV1%20Technical%20Drawing.pdf',
            label: 'VT33WGV1 Technical Drawing.pdf'
        },
        {
            href: 'https://vieunite.com/33%20Inch%20Beyond%20HD%20Textura%20Pro%20Digital%20Canvas%20-%20VT33WGV1.pdf',
            label: '33 Inch Beyond HD Textura Pro Digital Canvas - VT33WGV1.pdf'
        },
        {
            href: 'https://vieunite.com/Vieunite%20Pro%20-%20VT55WGV1%20-%20Manual%20Version%20V1.0[57].pdf',
            label: 'Vieunite Pro - VT55WGV1 - Manual Version V1.0[57].pdf'
        }
    ],
    contactText: 'Ready to turn your business space into a powerful communication tool with Vieunite Pro?',
    contactButtonText: 'CONTACT US'
};

const ProCommodity33 = () => <ProCommodity55 config={PRODUCT_CONFIG}/>;

export default ProCommodity33;
